import { useContext, useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../../services/api"
import type { DiMaDetailsHeaderProps } from "../../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../../components/DiMaProgress"
import { UserContext } from "../../../../context/UserContext"
import { ApplicationKeyValuePairGet } from "../../../../models/ApplicationKeyValuePair"
import { ApplicationKeyValuePairDetails } from "./details_tab/ApplicationKeyValuePairDetails"
import { renderDetailsTabSection } from "../../../../components/Helpers"
import { useHashTab } from "../../../../../hooks/useHashTab"

export function ApplicationKeyValuePairContainer() {
  const { user, isLoadingUser } = useContext(UserContext)
  const { applicationId, keyValuePairId } = useParams()
  const navigate = useNavigate()

  const { activeTab, handleTabChange: handleChange } = useHashTab("details")

  const [applicationKeyValuePair, setApplicationKeyValuePair] =
    useState<ApplicationKeyValuePairGet>()

  const returnURL = `/applications/${applicationId}#key-value-pairs`

  useEffect(() => {
    if (applicationId) {
      digitalManagerApi
        .get<ApplicationKeyValuePairGet>(
          `/applications/${applicationId}/keyValuePairs/${keyValuePairId}`
        )
        .then((res) => {
          setApplicationKeyValuePair(res.data)
        })
        .catch((err) => {
          if (err.response.status) {
            navigate(returnURL)
          }
        })
    }
  }, [applicationId, keyValuePairId, navigate, returnURL])

  if (!applicationId || !keyValuePairId) {
    return <Navigate to="/applications" />
  }

  if (!applicationKeyValuePair || isLoadingUser || !user) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: applicationKeyValuePair.key,
    label: "Key-Value Pair ID",
    subtitle: applicationKeyValuePair.id,
  }

  return renderDetailsTabSection({
    detailsHeaderProps,
    activeTab,
    handleTabChange: handleChange,
    DetailsComponent: ApplicationKeyValuePairDetails,
    detailsComponentProps: {
      applicationKeyValuePair,
      applicationId,
      user,
      setApplicationKeyValuePair,
    },
  })
}
